import { render, staticRenderFns } from "./MasterPassword.vue?vue&type=template&id=93ab956a"
import script from "./MasterPassword.vue?vue&type=script&lang=js"
export * from "./MasterPassword.vue?vue&type=script&lang=js"
import style0 from "./MasterPassword.vue?vue&type=style&index=0&id=93ab956a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports